import axios from '@/plugins/axios.js';

const flashcardService = {
    async getFlashcardSet(flashcardSetId) {
        const response = await axios.get(`/api/flashcard-sets/${flashcardSetId}`);
        return response.data.data;
    },

    async createFlashcardSet(data) {
        const response = await axios.post('/api/flashcard-sets', data);
        return response.data.data;
    },

    async updateFlashcardSet(flashcardSetId, data) {
        const response = await axios.put(`/api/flashcard-sets/${flashcardSetId}`, data);
        return response.data.data;
    },

    async deleteFlashcardSet(flashcardSetId) {
        await axios.delete(`/api/flashcard-sets/${flashcardSetId}`);
    },

    // Reserved for future inline editing
    async addCard(flashcardSetId, cardData) {
        const response = await axios.post(`/api/flashcard-sets/${flashcardSetId}/cards`, cardData);
        return response.data.data;
    },

    // Reserved for future inline editing
    async updateCard(flashcardSetId, cardId, cardData) {
        const response = await axios.put(`/api/flashcard-sets/${flashcardSetId}/cards/${cardId}`, cardData);
        return response.data.data;
    },

    // Reserved for future inline editing
    async deleteCard(flashcardSetId, cardId) {
        await axios.delete(`/api/flashcard-sets/${flashcardSetId}/cards/${cardId}`);
    },

    async getSession(activityId) {
        const response = await axios.get(`/api/activities/${activityId}/flashcard-session`);
        return response.data;
    },

    async submitResponses(activityId, cardResponses) {
        const response = await axios.post(`/api/activities/${activityId}/flashcard-session`, {
            card_responses: cardResponses,
        });
        return response.data;
    },

    async generateFlashcards(data) {
        const response = await axios.post('/api/flashcard/generate', data);
        return response.data.data;
    },

    async regenerateCard(data) {
        const response = await axios.post('/api/flashcard/regenerate-card', data);
        return response.data.data;
    },

    async regenerateSectionImage(data) {
        const response = await axios.post('/api/flashcard/regenerate-section-image', data);
        return response.data.data;
    },
};

export default flashcardService;
